module.exports = __webpack_public_path__ + "img/m_logo.30eb3c46.png";